// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"329":"793fa0399c2b9c9f","5418":"d983689097de6df8","8980":"2f730ad56ccdf253"}[chunkId] + ".css";
};